$(document).on("recalcCombinacion", function () {
  var cantidadActual = 0;
  var combinacion = [];
  $(".kaldos-sabor-add").each(function (index, item) {
    let name = $(item).attr("data-name");
    let cantidad = Number($(item).attr("data-cantidad") || "0");
    cantidadActual += cantidad;
    if (cantidad > 0) {
      combinacion.push(`${cantidad} de ${name}`);
    }
    $(item)
      .parents(".kaldos-stepper")
      .find(".kaldos-sabor-counter-stepper")
      .text(cantidad)
      .show();
  });
  var combinacionFinal = combinacion.join(",");

  if ($('[name="tipo_armado"]:checked').val() == "RECOMENDACION") {
    combinacionFinal = `RECOMENDACIÓN KEAT ${cantidadActual}`;
  }

  $("#combinacion").val(combinacionFinal);

  var disponibles = window.piezas - cantidadActual;
  if (disponibles <= 0) {
    disponibles = 0;
  }

  if (disponibles == 0) {
    $("#disponibles").parent().hide();
  } else {
    $("#disponibles").parent().show();
  }
  $("#disponibles").text(disponibles);

  if (window.esMobile) {
    var ancho = `${window.innerWidth / window.piezas}px`;
    $(".kaldos-barra-segmento").attr(
      "style",
      `width:${ancho} !important;max-width:${ancho} !important`
    );
  }

  $(".kaldos-barra-progreso").removeClass("visible");
  $("#kaldos-" + window.piezas).addClass("visible");
  $(".kaldos-barra-segmento").removeClass("completo");
  for (let i = 0; i < cantidadActual; i++) {
    $("#kaldos-" + window.piezas)
      .find(".kaldos-barra-segmento:eq(" + i + ")")
      .addClass("completo");
  }

  if (disponibles == 0) {
    if (!window.firstLoad) {
      toastMixin.fire({
        title: "Tu selección ya está completa.",
      });
    }
  }
  setTimeout(function () {
    if (
      Number(cantidadActual) == 0 ||
      Number(cantidadActual) != Number(window.piezas) ||
      disponibles != 0
    ) {
      $(".product-form__submit").attr("disabled", true);
    }
    if (Number(cantidadActual) == Number(window.piezas) && disponibles == 0) {
      $(".product-form__submit").removeAttr("disabled");
    }
  }, 450);
});

function setPrecioBoton(selling_plan) {
  let currency = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });

  if (!window.productoDestacado) {
    return;
  }
  if (!productoActual) {
    return;
  }

  let productoDestacado = window.productoDestacado || productoActual.variants;

  $(".precio-en-boton").remove();
  setTimeout(() => {
    const producto = productoDestacado.find(
      (item) => item.title == window.piezas
    );
    const precio =
      (producto.selling_plan_allocations[0].compare_at_price -
        producto.selling_plan_allocations[0].per_delivery_price) /
      100;

    $(".sls-original-price .conversion-bear-money").text(
      "Ahorra " + currency.format(precio)
    );
  }, 450);
  setTimeout(() => {
    $(".precio-en-boton").remove();
    const productoBoton = productoDestacado.find(
      (item) => item.title == window.piezas
    );
    let precio =
      productoDestacado.find((item) => item.title == window.piezas).price / 100;
    if (selling_plan) {
      if (isNaN(parseFloat(selling_plan))) {
        const sellingPlan = productoBoton.selling_plan_allocations.find(
          (selling_plan) => (selling_plan.id = selling_plan)
        );
        precio = sellingPlan.price / 100;
      } else {
        precio = selling_plan / 100;
      }
    }

    $(
      "#ProductSubmitButton-template--21508447994161__301f7d81-8bb3-4809-89de-61830541f62f"
    ).prepend(
      "<span class='precio-en-boton'>" + currency.format(precio) + "  </span>"
    );
  }, 750);
}
function validateSuscripcion() {
  /*if (Number(window.piezas) === 7) {
    $("#shopify-block-seal_subscriptions_subscription_widget_CqCL6C").hide();
  } else {
    $("#shopify-block-seal_subscriptions_subscription_widget_CqCL6C").show();
    if (
      typeof window.SealSubs !== "undefined" &&
      typeof window.SealSubs.refresh === "function"
    ) {
      window.SealSubs.refresh();
    }
  }*/
}
function setPrecioPorPieza(hayPlan) {
  if (hayPlan) {
    $(
      '[for="template--21508447994161__301f7d81-8bb3-4809-89de-61830541f62f-1-0"]'
    ).attr("data-ahorro", "12");
    $(
      '[for="template--21508447994161__301f7d81-8bb3-4809-89de-61830541f62f-1-1"]'
    ).attr("data-ahorro", "12");
    $(
      '[for="template--21508447994161__301f7d81-8bb3-4809-89de-61830541f62f-1-2"]'
    ).attr("data-ahorro", "15");
    $(
      '[for="template--21508447994161__301f7d81-8bb3-4809-89de-61830541f62f-1-3"]'
    ).attr("data-ahorro", "16");
    $(".precio-por-paquete:eq(0) span:eq(0)").text("$145");
    $(".precio-por-paquete:eq(1) span:eq(0)").text("$145");
    $(".precio-por-paquete:eq(2) span:eq(0)").text("$141");
    $(".precio-por-paquete:eq(3) span:eq(0)").text("$138");
  } else {
    $(
      '[for="template--21508447994161__301f7d81-8bb3-4809-89de-61830541f62f-1-0"]'
    ).attr("data-ahorro", "0");
    $(
      '[for="template--21508447994161__301f7d81-8bb3-4809-89de-61830541f62f-1-1"]'
    ).attr("data-ahorro", "0");
    $(
      '[for="template--21508447994161__301f7d81-8bb3-4809-89de-61830541f62f-1-2"]'
    ).attr("data-ahorro", "3");
    $(
      '[for="template--21508447994161__301f7d81-8bb3-4809-89de-61830541f62f-1-3"]'
    ).attr("data-ahorro", "5");
    $(".precio-por-paquete:eq(0) span:eq(0)").text("$165");
    $(".precio-por-paquete:eq(1) span:eq(0)").text("$165");
    $(".precio-por-paquete:eq(2) span:eq(0)").text("$160");
    $(".precio-por-paquete:eq(3) span:eq(0)").text("$157");
  }
}

function limpiarKaldos() {
  $(".kaldos-sabor-add").attr("data-cantidad", 0);
  $(".kaldos-sabor-counter").html('<div class="plus radius"></div>');
  $(".kaldos-sabor-counter").show();
  $(".kaldo-contenedor").show();
  $(".kaldos-stepper").removeClass("visible");
}

function recomendacionKeat() {
  var opcion = $('[name="tipo_armado"]:checked').val();
  if (opcion == "RECOMENDACION") {
    limpiarKaldos();
    if (window.piezas == 7) {
      $(".kaldos-sabor-add[data-name='NATURAL DIGESTIVO']").attr(
        "data-cantidad",
        0
      );
      $(
        ".kaldos-sabor-add[data-name='RES CURCUMA Y ZANAHORIA DESINFLAMATORIO']"
      ).attr("data-cantidad", 0);
      $(".kaldos-sabor-add[data-name='POLLO BROCOLI Y NOPAL HEPATICO']").attr(
        "data-cantidad",
        0
      );
      $(".kaldos-sabor-add[data-name='RES PORTOBELLO E HIGADO HEPATICO']").attr(
        "data-cantidad",
        0
      );
      $(".kaldos-sabor-add[data-name='POLLO ALBAHACA Y COCO HEPATICO']").attr(
        "data-cantidad",
        0
      );
      $(".kaldos-sabor-add[data-name='RES BETABEL Y APIO METABOLICO']").attr(
        "data-cantidad",
        0
      );
      $(".kaldos-sabor-add[data-name='POLLO BETABEL Y APIO METABOLICO']").attr(
        "data-cantidad",
        0
      );
      $(".kaldos-sabor-add[data-name='RES RECETA ORIGINAL  DIGESTIVO']").attr(
        "data-cantidad",
        1
      );
      $(".kaldos-sabor-add[data-name='POLLO RECETA ORIGINAL DIGESTIVO']").attr(
        "data-cantidad",
        1
      );
      $(
        ".kaldos-sabor-add[data-name='POLLO CURCUMA Y ZANAHORIA DESINFLAMATORIO']"
      ).attr("data-cantidad", 1);
      $(".kaldos-sabor-add[data-name='RES BROCOLI Y NOPAL HEPATICO']").attr(
        "data-cantidad",
        1
      );
      $(
        ".kaldos-sabor-add[data-name='RES CILANTRO Y LECHUGA METABOLICO']"
      ).attr("data-cantidad", 1);
      $(
        ".kaldos-sabor-add[data-name='POLLO HIERBA LIMON Y MISO TEJIDO Y HUESOS']"
      ).attr("data-cantidad", 1);
      $(
        ".kaldos-sabor-add[data-name='POLLO JENGIBRE Y CALABAZA TEJIDO Y HUESOS']"
      ).attr("data-cantidad", 1);
    }
    if (window.piezas == 14) {
      $(".kaldos-sabor-add[data-name='NATURAL DIGESTIVO']").attr(
        "data-cantidad",
        0
      );
      $(".kaldos-sabor-add[data-name='RES RECETA ORIGINAL  DIGESTIVO']").attr(
        "data-cantidad",
        1
      );
      $(".kaldos-sabor-add[data-name='POLLO RECETA ORIGINAL DIGESTIVO']").attr(
        "data-cantidad",
        1
      );
      $(
        ".kaldos-sabor-add[data-name='RES CURCUMA Y ZANAHORIA DESINFLAMATORIO']"
      ).attr("data-cantidad", 1);
      $(
        ".kaldos-sabor-add[data-name='POLLO CURCUMA Y ZANAHORIA DESINFLAMATORIO']"
      ).attr("data-cantidad", 1);
      $(".kaldos-sabor-add[data-name='RES BROCOLI Y NOPAL HEPATICO']").attr(
        "data-cantidad",
        1
      );
      $(".kaldos-sabor-add[data-name='POLLO BROCOLI Y NOPAL HEPATICO']").attr(
        "data-cantidad",
        1
      );
      $(".kaldos-sabor-add[data-name='RES PORTOBELLO E HIGADO HEPATICO']").attr(
        "data-cantidad",
        1
      );
      $(".kaldos-sabor-add[data-name='POLLO ALBAHACA Y COCO HEPATICO']").attr(
        "data-cantidad",
        1
      );
      $(".kaldos-sabor-add[data-name='RES BETABEL Y APIO METABOLICO']").attr(
        "data-cantidad",
        1
      );
      $(".kaldos-sabor-add[data-name='POLLO BETABEL Y APIO METABOLICO']").attr(
        "data-cantidad",
        1
      );
      $(
        ".kaldos-sabor-add[data-name='RES CILANTRO Y LECHUGA METABOLICO']"
      ).attr("data-cantidad", 2);
      $(
        ".kaldos-sabor-add[data-name='POLLO HIERBA LIMON Y MISO TEJIDO Y HUESOS']"
      ).attr("data-cantidad", 1);
      $(
        ".kaldos-sabor-add[data-name='POLLO JENGIBRE Y CALABAZA TEJIDO Y HUESOS']"
      ).attr("data-cantidad", 1);
    }
    if (window.piezas == 21) {
      $(".kaldos-sabor-add[data-name='NATURAL DIGESTIVO']").attr(
        "data-cantidad",
        0
      );
      $(".kaldos-sabor-add[data-name='RES RECETA ORIGINAL  DIGESTIVO']").attr(
        "data-cantidad",
        2
      );
      $(".kaldos-sabor-add[data-name='POLLO RECETA ORIGINAL DIGESTIVO']").attr(
        "data-cantidad",
        2
      );
      $(
        ".kaldos-sabor-add[data-name='RES CURCUMA Y ZANAHORIA DESINFLAMATORIO']"
      ).attr("data-cantidad", 2);
      $(
        ".kaldos-sabor-add[data-name='POLLO CURCUMA Y ZANAHORIA DESINFLAMATORIO']"
      ).attr("data-cantidad", 2);
      $(".kaldos-sabor-add[data-name='RES BROCOLI Y NOPAL HEPATICO']").attr(
        "data-cantidad",
        2
      );
      $(".kaldos-sabor-add[data-name='POLLO BROCOLI Y NOPAL HEPATICO']").attr(
        "data-cantidad",
        2
      );
      $(".kaldos-sabor-add[data-name='RES PORTOBELLO E HIGADO HEPATICO']").attr(
        "data-cantidad",
        1
      );
      $(".kaldos-sabor-add[data-name='POLLO ALBAHACA Y COCO HEPATICO']").attr(
        "data-cantidad",
        2
      );
      $(".kaldos-sabor-add[data-name='RES BETABEL Y APIO METABOLICO']").attr(
        "data-cantidad",
        2
      );
      $(".kaldos-sabor-add[data-name='POLLO BETABEL Y APIO METABOLICO']").attr(
        "data-cantidad",
        1
      );
      $(
        ".kaldos-sabor-add[data-name='RES CILANTRO Y LECHUGA METABOLICO']"
      ).attr("data-cantidad", 1);
      $(
        ".kaldos-sabor-add[data-name='POLLO HIERBA LIMON Y MISO TEJIDO Y HUESOS']"
      ).attr("data-cantidad", 1);
      $(
        ".kaldos-sabor-add[data-name='POLLO JENGIBRE Y CALABAZA TEJIDO Y HUESOS']"
      ).attr("data-cantidad", 1);
    }
    if (window.piezas == 28) {
      $(".kaldos-sabor-add[data-name='RES RECETA ORIGINAL  DIGESTIVO']").attr(
        "data-cantidad",
        3
      );
      $(".kaldos-sabor-add[data-name='POLLO RECETA ORIGINAL DIGESTIVO']").attr(
        "data-cantidad",
        3
      );
      $(".kaldos-sabor-add[data-name='NATURAL DIGESTIVO']").attr(
        "data-cantidad",
        0
      );
      $(
        ".kaldos-sabor-add[data-name='RES CURCUMA Y ZANAHORIA DESINFLAMATORIO']"
      ).attr("data-cantidad", 2);
      $(
        ".kaldos-sabor-add[data-name='POLLO CURCUMA Y ZANAHORIA DESINFLAMATORIO']"
      ).attr("data-cantidad", 2);
      $(".kaldos-sabor-add[data-name='RES BROCOLI Y NOPAL HEPATICO']").attr(
        "data-cantidad",
        2
      );
      $(".kaldos-sabor-add[data-name='POLLO BROCOLI Y NOPAL HEPATICO']").attr(
        "data-cantidad",
        2
      );
      $(".kaldos-sabor-add[data-name='RES PORTOBELLO E HIGADO HEPATICO']").attr(
        "data-cantidad",
        1
      );
      $(".kaldos-sabor-add[data-name='POLLO ALBAHACA Y COCO HEPATICO']").attr(
        "data-cantidad",
        3
      );
      $(".kaldos-sabor-add[data-name='RES BETABEL Y APIO METABOLICO']").attr(
        "data-cantidad",
        2
      );
      $(".kaldos-sabor-add[data-name='POLLO BETABEL Y APIO METABOLICO']").attr(
        "data-cantidad",
        2
      );
      $(
        ".kaldos-sabor-add[data-name='RES CILANTRO Y LECHUGA METABOLICO']"
      ).attr("data-cantidad", 2);
      $(
        ".kaldos-sabor-add[data-name='POLLO HIERBA LIMON Y MISO TEJIDO Y HUESOS']"
      ).attr("data-cantidad", 2);
      $(
        ".kaldos-sabor-add[data-name='POLLO JENGIBRE Y CALABAZA TEJIDO Y HUESOS']"
      ).attr("data-cantidad", 2);
    }

    $(".kaldos-sabor-add").each(function () {
      var cantidad = $(this).attr("data-cantidad");
      if (cantidad > 0) {
        $(this)
          .parents(".kaldo-contenedor")
          .find(".kaldos-sabor-counter")
          .html(`<div class="kaldos-sabor-counter-cantidad">${cantidad}</div>`);
        $(this).parents(".kaldo-contenedor").show();
      } else {
        $(this).parents(".kaldo-contenedor").hide();
      }
    });

    $(".kaldos-stepper").removeClass("visible");
    $(".kaldos-sabor-counter").show();
  }
}

$(document).on("input", '[name="tipo_armado"]', function (e) {
  var opcion = $(this).val();
  $("#kaldos-base-opciones-contenedor").show();
  if (opcion == "RECOMENDACION") {
    $("#kaldos-base-progreso").removeClass("activo");
    recomendacionKeat();
  } else {
    $("#kaldos-base-progreso").addClass("activo");
    if (!window.blockLimpiar) {
      limpiarKaldos();
    } else {
      window.blockLimpiar = false;
    }
  }

  $(document).trigger("recalcCombinacion");
});

$(document).ready(function () {
  if ($("#ProductBuilderComponentKaldos").length) {
    window.firstLoad = true;
    window.toastMixin = Swal.mixin({
      toast: true,
      icon: "success",
      title: "General Title",
      animation: true,
      position: "top-right",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: false,
    });

    setTimeout(function () {
      $(
        ".product__media-toggle.quick-add-hidden.product__media-zoom-lightbox"
      ).remove();
      window.piezas = $(
        '[name="Elige el número de piezas (encontrás una pre-selección  Keat®)"]:checked'
      ).val();
      setPrecioBoton();
      $("#fecha-inicio-campo").remove();

      $(".product-form__submit").attr("disabled", true);
      window.piezas = Number(
        $(
          '[name="Elige el número de piezas (encontrás una pre-selección  Keat®)"]:checked'
        ).val()
      );
      $("#armado_recomendacion")
        .attr("checked", true)
        .trigger("change")
        .trigger("input");
      recomendacionKeat();

      $(document).trigger("recalcCombinacion");

      $(
        "#variant-radios-template--21508447994161__301f7d81-8bb3-4809-89de-61830541f62f .form__label"
      ).text("Elige el número de piezas.");

      $(".product-form__submit").attr("data-piezas", window.piezas);
    }, 700);
  }
});

$(document).on(
  "input",
  '[name="Elige el número de piezas (encontrás una pre-selección  Keat®)"]',
  function (e) {
    if (Number($(this).val()) < Number(window.piezas)) {
      limpiarKaldos();
    }
    window.piezas = Number($(this).val());
    recomendacionKeat();
    setPrecioBoton();
    $(document).trigger("recalcCombinacion");
    $(".product-form__submit").attr("data-piezas", window.piezas);
  }
);

$(document).on("click", ".kaldos-sabor-counter", function (e) {
  e.preventDefault();
  e.stopPropagation();
  if ($('[name="tipo_armado"]:checked').val() !== "RECOMENDACION") {
    $(".kaldos-sabor-counter").show();
    $(".kaldos-stepper").removeClass("visible");
    $(this).hide();
    var kaldosSaborAdd = $(this)
      .parents(".kaldo-contenedor")
      .find(".kaldos-sabor-add");
    if (Number(kaldosSaborAdd.attr("data-cantidad") || "0") == 0) {
      kaldosSaborAdd.click();
    }
    $(this).parent().find(".kaldos-stepper").toggleClass("visible");
  }
  return false;
});

$(document).on("click", ".kaldos-sabor-add", function (e) {
  e.preventDefault();
  window.firstLoad = false;
  var el = $(this);
  if ($('[name="tipo_armado"]:checked').val() !== "RECOMENDACION") {
    var cantidad = Number(el.attr("data-cantidad") || "0") + 1;
    $(document).trigger("recalcCombinacion");
    var cantidadActual = 0;
    $(".kaldos-sabor-add").each(function (index, item) {
      cantidadActual += Number($(item).attr("data-cantidad") || "0");
    });
    if (cantidadActual < window.piezas) {
      el.attr("data-cantidad", cantidad);
      el.parents(".kaldos-stepper")
        .find(".kaldos-sabor-counter-stepper")
        .text(cantidad);
      el.parents(".kaldo-contenedor")
        .find(".kaldos-sabor-counter")
        .html(`<div class="kaldos-sabor-counter-cantidad">${cantidad}</div>`);
      $(document).trigger("recalcCombinacion");
    }
  }

  return false;
});

$(document).on("click", ".kaldos-sabor-substract", function (e) {
  e.preventDefault();
  window.firstLoad = false;
  if ($('[name="tipo_armado"]:checked').val() === "RECOMENDACION") {
    window.blockLimpiar = true;
    $("#armado_personalizado").attr("checked", true).trigger("input");
  }

  var el = $(this);
  var kaldosAddBotton = el.parents(".kaldos-stepper").find(".kaldos-sabor-add");
  var cantidad = Number(kaldosAddBotton.attr("data-cantidad") || "0") - 1;
  if (cantidad <= 0) {
    cantidad = 0;
  }
  kaldosAddBotton.attr("data-cantidad", cantidad);
  $(this)
    .parents(".kaldos-stepper")
    .find(".kaldos-sabor-counter-stepper")
    .text(cantidad);
  $(document).trigger("recalcCombinacion");

  if (cantidad == 0) {
    $(this).parents(".kaldos-stepper").toggleClass("visible");
    $(this)
      .parents(".kaldo-contenedor")
      .find(".kaldos-sabor-counter")
      .html('<div class="plus radius"></div>')
      .show();
  }
  return false;
});

document.addEventListener("sealsubs:subscription_widget_created", function (e) {
  validateSuscripcion();
});

document.addEventListener("sealsubs:selling_plan_changed", function (e) {
  setPrecioPorPieza(e.detail.selling_plan_id);
  setPrecioBoton(e.detail.selling_plan_id);
});

document.addEventListener("sealsubs:price_update", function (e) {
  setPrecioBoton(e.detail.price);
});

window.esMobile = false;

const mql = window.matchMedia("(max-width: 768px)");
if (mql.matches) {
  $(".kaldos-base-opciones .keat-col-3:not(.en-kaldos-stepper)")
    .removeClass("keat-col-3")
    .addClass("keat-col-6");
  window.esMobile = true;
}

mql.onchange = (e) => {
  if (e.matches) {
    $(".kaldos-base-opciones .keat-col-3:not(.en-kaldos-stepper)")
      .removeClass("keat-col-3")
      .addClass("keat-col-6");
    window.esMobile = true;
  } else {
    $(".kaldos-base-opciones .keat-col-6:not(.en-kaldos-stepper)")
      .removeClass("keat-col-6")
      .addClass("keat-col-3");
    window.esMobile = false;
  }
};
